import React, { useEffect, useRef } from 'react';

const ProjectHeaderPanorama = ({
  onMouseOver = () => {},
  onMouseOut = () => {},
  viewState
}) => {
  const panoramaContainer = useRef(null);

  useEffect(() => {
    if (!viewState) return;
    const { latitude, longitude } = viewState;
    const address = `${latitude},${longitude}`;
    const panorama = new google.maps.StreetViewPanorama(
      panoramaContainer.current,
      {
        // position: { lat: 37.86926, lng: -122.254811 },
        address,
        pov: { heading: 165, pitch: 20 },
        zoom: 1,
        disableDefaultUI: true
      }
    );

    let myLatLng;
    const sv = new google.maps.StreetViewService();
    const geocoder = new google.maps.Geocoder();
    const directionsService = new google.maps.DirectionsService();
    const processSVData = (data, status) => {
      if (status === google.maps.StreetViewStatus.OK) {
        panorama.setPano(data.location.pano);

        const heading = google.maps.geometry.spherical.computeHeading(
          data.location.latLng,
          myLatLng
        );
        panorama.setPov({
          heading,
          pitch: 0,
          zoom: 1
        });

        panorama.setVisible(true);
      } else {
        document.getElementById('pano').style.display = 'none';
      }
    };

    geocoder.geocode(
      {
        address
      },
      (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          myLatLng = results[0].geometry.location;

          // find a Streetview location on the road
          const request = {
            origin: address,
            destination: address,
            travelMode: google.maps.DirectionsTravelMode.DRIVING
          };

          directionsService.route(request, (response, status) => {
            if (status === google.maps.DirectionsStatus.OK) {
              const latlng = response.routes[0].legs[0].start_location;
              const radius = 1000;
              sv.getPanorama(
                {
                  location: latlng,
                  radius,
                  source: google.maps.StreetViewSource.OUTDOOR
                },
                processSVData
              );
            }
          });
        }
      }
    );

    return () => {
      panorama.setVisible(false);
    };
  }, [viewState]);

  return (
    <div
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onFocus={onMouseOver}
      onBlur={onMouseOut}
      className="street-view-panorama"
      style={{
        pointerEvents: 'all',
        zIndex: 500
      }}
    >
      <div ref={panoramaContainer} />
    </div>
  );
};

export default React.memo(ProjectHeaderPanorama);
